export const LIGHT = 'LIGHT';
export const DARK = 'DARK';